module.exports = __webpack_public_path__ + "static/6305-woodrose-35-e2a05d8095d1d60fe677af20c3d31b99.jpg";